/**
 * Label for a Cmd/Ctrl shortcut, matching the modifier the key handlers accept
 * on the viewer's platform: "⌘K" on macOS, "Ctrl+K" everywhere else.
 *
 * @example
 * modKeyLabel("K") // "⌘K" on macOS, "Ctrl+K" on Windows/Linux
 */
export function modKeyLabel(key: string, platform: string = currentPlatform()): string {
  return isMacPlatform(platform) ? `⌘${key}` : `Ctrl+${key}`;
}

export function isMacPlatform(platform: string): boolean {
  return /mac|iphone|ipad|ipod/i.test(platform);
}

function currentPlatform(): string {
  if (typeof navigator === "undefined") return "";
  const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  return uaData?.platform || navigator.platform || "";
}
